module.exports = __webpack_public_path__ + "img/spencer-davis-xyilWXHQMLo-unsplash.45b40e8d.jpg";